import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import compose from "lodash/flowRight";

import {ResetPasswordPage} from "shared/PasswordReset/containers/ResetPassword/ResetPasswordPage";

const ResetPasswordLayout = (props) => {
    return (
        <ResetPasswordPage
            token={props.match.params.token}
            userId={props.match.params.userId}
            onComplete={(redirectUrl) =>
                props.history.push({
                    pathname: `/auth/reset${props.isApplicant ? "/applicant" : ""}/complete`,
                    state: {redirectUrl},
                })
            }
        />
    );
};

export default compose(connect(), withRouter)(ResetPasswordLayout);
